var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMauritius(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 4",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#00A551",
    width: 6,
    height: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#FFD500",
    width: 6,
    height: 3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#1A206D",
    width: 6,
    height: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    fill: "#EA2839",
    width: 6,
    height: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMauritius);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2IDQiPgo8cmVjdCBmaWxsPSIjMDBBNTUxIiB3aWR0aD0iNiIgaGVpZ2h0PSI0Ii8+CjxyZWN0IGZpbGw9IiNGRkQ1MDAiIHdpZHRoPSI2IiBoZWlnaHQ9IjMiLz4KPHJlY3QgZmlsbD0iIzFBMjA2RCIgd2lkdGg9IjYiIGhlaWdodD0iMiIvPgo8cmVjdCBmaWxsPSIjRUEyODM5IiB3aWR0aD0iNiIgaGVpZ2h0PSIxIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };